<template>
  <v-div style="margin: 0 !important; max-width: 100% !important;">
    <v-card
      elevation="0"
      style="
        margin-top: 0;
        margin-bottom: -30px;
        overflow: hidden;
        background-color: transparent;
      "
      class="px-5 py-1"
    >
      <v-row
        class="custom-gray-background fill-width d-flex justify-start align-center"
        v-if="mostrarFiltro"
      >
        <v-col cols="12" sm="6" md="2">
          <span>Competência inicial *</span>
          <v-menu
            v-model="initialCompetenceMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="formatCompetence(initialCompetence)"
                label="Mês/Ano inicial"
                dense
                solo-inverted
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="initialCompetence"
              type="month"
              no-title
              :max="finalCompetence || currentCompetence"
              @input="initialCompetenceMenu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" sm="6" md="2">
          <span>Competência final *</span>
          <v-menu
            v-model="finalCompetenceMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="formatCompetence(finalCompetence)"
                label="Mês/Ano final"
                dense
                solo-inverted
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="finalCompetence"
              type="month"
              no-title
              :min="initialCompetence"
              :max="currentCompetence"
              @input="finalCompetenceMenu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <span>Empresa *</span>
          <v-select
            v-model="selectedCompany"
            :items="filteredEmpresas"
            label="Empresa"
            dense
            solo-inverted
          ></v-select>
        </v-col>

        <v-col cols="12" sm="6" md="2">
          <span>Tipo de venda</span>
          <v-autocomplete
            v-model="selectedSaleTypes"
            :items="saleTypes"
            label="Tipo de venda"
            multiple
            clearable
            small-chips
            deletable-chips
            dense
            solo-inverted
          ></v-autocomplete>
        </v-col>

        <v-col v-if="!isRestrictedSeller" cols="12" sm="6" md="3">
          <span>Vendedor</span>
          <v-autocomplete
            v-model="selectedSellerIds"
            :items="sellerOptions"
            item-text="nomeFuncionario"
            item-value="idFuncionario"
            label="Vendedor"
            :loading="sellersLoading"
            :disabled="!canLoadSellers"
            no-data-text="Nenhum vendedor encontrado"
            multiple
            clearable
            small-chips
            deletable-chips
            dense
            solo-inverted
          ></v-autocomplete>
        </v-col>
      </v-row>

      <v-divider></v-divider>

      <v-card-actions class="justify-end">
        <v-btn
          @click="alternarVisibilidade"
          color="#4682B4"
          small
          class="mr-2"
          style="font-size: 14px; font-weight: bold"
        >
          {{ mostrarFiltro ? "Ocultar Filtro" : "Mostrar Filtro" }}
          <v-icon style="margin-left: 8px" dark>
            {{ mostrarFiltro ? "mdi-eye-off" : "mdi-eye" }}
          </v-icon>
        </v-btn>

        <v-btn
          @click="limparFiltro"
          v-if="mostrarFiltro"
          color="#4682B4"
          small
          outlined
          class="mr-2"
          style="font-size: 14px; font-weight: bold"
        >
          Limpar
        </v-btn>
        <v-btn
          @click="filtrar"
          v-if="mostrarFiltro"
          color="#4682B4"
          small
          style="font-size: 14px; font-weight: bold"
        >
          Filtrar
          <v-icon style="margin-left: 8px" dark>mdi-filter</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-div>
</template>

<script>
import Financeiro from "../../../services/financeiro";

export default {
  props: {
    opcoes: { type: Array, default: () => [] },
    modos: { type: Array, default: () => [] },
    tipos: { type: Array, default: () => [] },
    title_opcao: { type: String, default: "" },
  },

  data() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = String(currentDate.getMonth() + 1).padStart(2, "0");
    const currentCompetence = `${currentYear}-${currentMonth}`;

    return {
      mostrarFiltro: true,
      initialCompetenceMenu: false,
      finalCompetenceMenu: false,
      currentCompetence,
      initialCompetence: `${currentYear}-01`,
      finalCompetence: currentCompetence,
      selectedCompany: "",
      selectedSaleTypes: [],
      selectedSellerIds: [],
      sellerOptions: [],
      sellersLoading: false,
      sellerReloadTimer: null,
      sellerRequestId: 0,
      saleTypes: ["MIGRAÇÃO DE PLANO", "VENDA NOVA", "READEQUAÇÃO"],
      selectedType: "Todos",
      selectedOpcao: "Todas",
      selectMode: "",
      months: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
      empresas: [
        "A FLOR DO CAFÉ",
        "CEMITERIO PREVIDA",
        "CEMITERIO PREVIDA SÃO MIGUEL",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DAS FLORES",
        "PARQUE DO AGRESTE",
        "PREVIDA",
      ],
    };
  },

  computed: {
    filteredEmpresas() {
      return this.empresas.filter((empresa) => this.hasPermission(empresa));
    },
    isRestrictedSeller() {
      try {
        const user = JSON.parse(sessionStorage.getItem("user"));
        const roles = user && Array.isArray(user.roles) ? user.roles : [];

        return (
          roles.includes("ROLE_RETENCAO_VENDEDOR") &&
          !roles.includes("ROLE_RETENCAO") &&
          !roles.includes("ROLE_ADMIN")
        );
      } catch (error) {
        return false;
      }
    },
    canLoadSellers() {
      return Boolean(
        !this.isRestrictedSeller &&
          this.selectedCompany &&
          this.initialCompetence &&
          this.finalCompetence &&
          this.initialCompetence <= this.finalCompetence
      );
    },
  },

  watch: {
    filteredEmpresas: {
      immediate: true,
      handler(empresas) {
        if (empresas.length === 1) {
          this.selectedCompany = empresas[0];
        }
      },
    },
    selectedCompany() {
      this.scheduleSellerReload();
    },
    initialCompetence() {
      this.scheduleSellerReload();
    },
    finalCompetence() {
      this.scheduleSellerReload();
    },
  },

  beforeDestroy() {
    clearTimeout(this.sellerReloadTimer);
  },

  methods: {
    hasPermission(empresa) {
      try {
        const user = JSON.parse(sessionStorage.getItem("user"));
        const roles = user && Array.isArray(user.roles) ? user.roles : [];

        if (roles.includes("ROLE_ADMIN")) {
          return true;
        }

        const requiredRole =
          "ROLE_" + empresa.trim().toUpperCase().replace(/\s/g, "_");
        return roles.includes(requiredRole);
      } catch (error) {
        return false;
      }
    },
    alternarVisibilidade() {
      this.mostrarFiltro = !this.mostrarFiltro;
    },
    limparFiltro() {
      const currentYear = new Date().getFullYear();
      this.initialCompetence = `${currentYear}-01`;
      this.finalCompetence = this.currentCompetence;
      this.selectedCompany = "";
      this.selectedSaleTypes = [];
      this.selectedSellerIds = [];
      this.sellerOptions = [];
    },
    formatCompetence(competence) {
      if (!competence) return "";
      const [year, month] = competence.split("-");
      return `${month}/${year}`;
    },
    scheduleSellerReload() {
      clearTimeout(this.sellerReloadTimer);
      const requestId = ++this.sellerRequestId;

      this.selectedSellerIds = [];
      this.sellerOptions = [];

      if (this.isRestrictedSeller) {
        this.sellersLoading = false;
        return;
      }

      if (!this.canLoadSellers) {
        this.sellersLoading = false;
        return;
      }

      this.sellersLoading = true;
      this.sellerReloadTimer = setTimeout(
        () => this.loadSellers(requestId),
        250
      );
    },
    async loadSellers(requestId) {
      try {
        const response = await Financeiro.vendedoresRetencao(
          `${this.initialCompetence}-01`,
          `${this.finalCompetence}-01`,
          this.selectedCompany
        );

        if (requestId === this.sellerRequestId) {
          this.sellerOptions = response.data || [];
        }
      } catch (error) {
        if (requestId === this.sellerRequestId) {
          this.sellerOptions = [];
          console.error("Erro ao buscar os vendedores:", error);
        }
      } finally {
        if (requestId === this.sellerRequestId) {
          this.sellersLoading = false;
        }
      }
    },
    filtrar() {
      if (
        !this.selectedCompany ||
        this.selectedCompany.length === 0 ||
        (this.selectedCompany.length === 1 && this.selectedCompany[0] === "")
      ) {
        // Se não houver empresa selecionada, emitir evento para mostrar o diálogo de erro
        this.$emit("showError", "Por favor, selecione pelo menos uma empresa.");
        return;
      }
      if (!this.initialCompetence || !this.finalCompetence) {
        this.$emit("showError", "Informe as competências inicial e final.");
        return;
      }
      if (this.initialCompetence > this.finalCompetence) {
        this.$emit(
          "showError",
          "A competência inicial não pode ser posterior à competência final."
        );
        return;
      }
      this.$emit("filtrar", {
        initialCompetence: this.initialCompetence,
        finalCompetence: this.finalCompetence,
        selectedCompany: this.selectedCompany,
        selectedSaleTypes: this.selectedSaleTypes,
        selectedSellerIds: this.selectedSellerIds,
      });
    },
  },
};
</script>
